import errorChecker from "./errorChecker";
import {apiEndpoint} from "../Constants/api";
import {getTokenFromLocalStorage} from "./getAuth";

export default async (
    _url: string,
    method: string,
    params: object = {},
    body = null,
    isJson: boolean = true,
    credentials: RequestCredentials = "same-origin",
    emptyResp: boolean = false
) => {
    let url = new URL(apiEndpoint + _url);
    Object.keys(params).forEach((key) => {
        if (Array.isArray(params[key])) {
            params[key].forEach((item) => url.searchParams.append(key, item));
        } else {
            url.searchParams.append(key, params[key]);
        }
    });
    let token;
    try {
        token = getTokenFromLocalStorage().token;
    } catch (err) {
        //
    }
    const headers = {
        "Content-Type": isJson ? "application/json;" : "application/x-www-form-urlencoded"
    };
    if (token) {
        const bearer = `Bearer ${token}`;
        Object.assign(headers, {Authorization: bearer});
    }
    const requestUrl = url.toString();
    const response = await fetch(requestUrl, {
        method,
        headers,
        credentials,
        body,
    });
    return errorChecker(response, emptyResp);
};